/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class  ManageDocumentSelectionService{
        constructor(private $http: angular.IHttpService, private $q: angular.IQService) { }

        public updateDocumentSelection(processId: string,
            manageSectionId: string,
            documentId: string,
            isSelected: boolean) : ng.IPromise<Wars.Domain.Model.Execution.DocumentSelection[]>{
            var d = this.$q.defer();

            this.$http.post('./api/process/' + processId + '/UpdateDocumentSelection/' + manageSectionId + '/document/' + documentId, isSelected)
                .then(r => { d.resolve(r.data); });

            return d.promise;
        }
    }
}

warsApp.registerService('ManageDocumentSelectionService', ['$http', '$q'])